// Copyright (c) 2017 Deere & Company

import Territories, {getDefaultState} from '../state/territories';
import actions from '../../actions-list';

const updateUserTerritories = (state, action) =>
    Territories.update(state, {
        $set: action.territories
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_AUDIT_SUMMARY_TERRITORIES]: updateUserTerritories
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/audit-summary/reducers/territories.js